import React from "react";
import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 20, className = "" }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.6, delay, ease: [0.34, 1.56, 0.64, 1] }}
    >
        {children}
    </motion.div>
);

export default Reveal;
